<template>
    <div class="page-container">
        <ThatsTable title="Delivery Schedule" ref="table" :multipleSelection="checkSystemSupport" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns" :newBtn="false" :height="'calc(100vh - 155px)'">
            <template #tabs>
                <mdb-tabs class="table-tabs" :active="active" default :links="[{ text: 'Delivery Schedule Request' }, { text: 'Delivery Today' }, { text: 'Delivery Tomorrow' },{ text: 'Pending' }, { text: 'Pull Out/Exchange' },{ text: 'Cancel/Re-schedule' },{ text: 'Finish' },{ text: 'Pull-Out Order' },{ text: 'All' }]"  @activeTab="getActiveTabIndex" />
            </template>
            <template  #filter="{dispatchFilter}">
                <DeliveryFilter @filter="dispatchFilter" :tabIndex="active"></DeliveryFilter>
            </template>
            
        </ThatsTable>
        <PullOutForm ref="pullOutForm" @success="refreshTable" @delete="formDelete"  :group="3"></PullOutForm>
        <DeliveryForm ref="dialogForm" @success="refreshTable" @delete="formDelete"  :group="3"></DeliveryForm>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import DeliveryForm from './DeliveryForm'
import PullOutForm from './PullOutForm'
import ThatsTable from './Table'
import DeliveryFilter from './DeliveryFilter.vue'
import {mdbTabs} from 'mdbvue'
import { MessageBox } from 'element-ui';
export default {
    data(){
        return {
            endpoint : 'delivery/data?status=for-delivery',    
            importData : {},        
            errorData : {},        
            importLoading : false,        
            active : 0,        
            activeTab : 0,        
            token : null,      
            columns : [
                {
                    label: 'Date Request',
                    field: 'date',
                    width : "120"
                },
                {
                    label: 'Tracking No.',
                    field: 'series_display',
                    clickable : true
                },
                {
                    label: 'Invoice Date',
                    field: 'invoice_date',
                },
                {
                    label: 'Item Name',
                    field: 'item_name',
                },
                {
                    label: 'Customer Mobile',
                    field: 'customer_mobile',
                },
                {
                    label: 'Total Amount',
                    field: 'total',
                },
                {
                    label: 'Sold By',
                    field: 'sold_by',
                },
                {
                    label: 'Remarks',
                    field: 'description',
                },

            ],  
            columnOne : [
               {
                    label: 'Date Request',
                    field: 'date',
                    width : "120"
                },
                {
                    label: 'Tracking No.',
                    field: 'series_display',
                    clickable : true
                },
                {
                    label: 'Invoice Date',
                    field: 'invoice_date',
                },
                {
                    label: 'Item Name',
                    field: 'item_name',
                },
                {
                    label: 'Customer Mobile',
                    field: 'customer_mobile',
                },
                {
                    label: 'Total Amount',
                    field: 'total',
                },
                {
                    label: 'Sold By',
                    field: 'sold_by',
                },
                {
                    label: 'Remarks',
                    field: 'description',
                },

            ],  
            columnTwo : [
                 {
                    label: 'Date Delivery',
                    field: 'delivery_date',
                    width : "120"
                },
                {
                    label: 'Time',
                    field: 'delivery_time',
                    width : "100"
                },
                {
                    label: 'Tracking No.',
                    field: 'series_display',
                    clickable : true
                },
                {
                    label: 'Invoice Date',
                    field: 'invoice_date',
                },
                {
                    label: 'Item Name',
                    field: 'item_name',
                },
                {
                    label: 'Customer Mobile',
                    field: 'customer_mobile',
                },
                {
                    label: 'Total Amount',
                    field: 'total',
                },
                {
                    label: 'Sold By',
                    field: 'sold_by',
                },
                {
                    label: 'Remarks',
                    field: 'description',
                },

            ],  
            columnAll : [
                 {
                    label: 'Date Request',
                    field: 'date',
                    width : "120"
                },
                {
                    label: 'Date Delivery',
                    field: 'delivery_date',
                    width : "120"
                },
                {
                    label: 'Time',
                    field: 'delivery_time',
                    width : "100"
                },
                {
                    label: 'Tracking No.',
                    field: 'series_display',
                    clickable : true
                },
                {
                    label: 'Invoice Date',
                    field: 'invoice_date',
                },
                {
                    label: 'Item Name',
                    field: 'item_name',
                },
                {
                    label: 'Customer Mobile',
                    field: 'customer_mobile',
                },
                {
                    label: 'Total Amount',
                    field: 'total',
                },
                {
                    label: 'Sold By',
                    field: 'sold_by',
                },
                {
                    label: 'Remarks',
                    field: 'description',
                },

            ]  
        }
    },
    components:{
        PullOutForm,
        DeliveryForm,
        ThatsTable,
        DeliveryFilter,
        mdbTabs,

    },

    
    methods: {
        // 

        ...mapActions('TableModule',[
            'resetData',
        ]),
        ...mapMutations('TableModule',[
            'SetPage',
            'SetTerm',
            'SetFilters',
        ]),

        ...mapActions('DeliveryModule',[ 'DeleteRecord','saveImport' ,'updateStatus','getRecord','getPullOutRecord']),
        ...mapMutations('DeliveryModule',[ 'setFormRecord', 'setFormStatusUpdate','setTabIndex']),

        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.DeleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })
            this.closeWindow()
        },
        OpenUpdateModal(obj){
            var self = this;

             

            const form  = {...obj.row,
                    items : [],
                    delivery : [],
                    delivered_items : [],
                    attachment : [], 
                    invoice : {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    }}           
            self.setFormStatusUpdate()
            self.setFormRecord(form)
            
            if(this.activeTab !=='pull-out'){
                self.getRecord({token_id : obj.row.token_id})
                self.openWindow()
            }else{
                self.getPullOutRecord({token_id : obj.row.token_id})
                 this.$refs.pullOutForm.openDialog()
            }

        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        },
        importProduct(){
           this.$refs.uploadForm.openDialog()
        },
        fileData(v){
            this.importData = v
            // console.log(v)
           
           this.$refs.tableImport.openDialog()
        },

        importNow(v){
            if(!this.importLoading){
                this.importLoading = true
                this.saveImport({ row : v}).then((response) => {

                    this.importLoading = false,
                    this.$ThatsNotify.success({
                        message : response.message,
                        timeOut : 10000
                    })
                    this.$refs.tableImport.closeDialog();
                    this.$refs.table.refreshTable()

                    if(response.error.rows.length > 0){
                        this.errorData = response.error
                        this.$refs.tableError.openDialog()
                    }

                    return;

                }).catch((error) => {
                    this.importLoading = false,
                    this.$ThatsNotify.warning({
                        message : `Please check file might some column of record has invalid value.`,
                        timeOut : 10000
                    })
                    this.$refs.table.refreshTable()
                })
            }
            
        },

        getActiveTabIndex(index){


            const tabs = ['for-delivery','scheduled-for-delivery','tomorrow-delivery','pending-delivery','pull-out','cancel-re-schedule','delivered','pull-out','all']

            this.endpoint = 'delivery/data?status='+tabs[index];

            this.activeTab = tabs[index]

            this.setTabIndex(index)
        
            if(tabs[index] === 'for-delivery'){
                this.columns = this.columnOne;
            }
            if(tabs[index] !== 'for-delivery'){
                this.columns = this.columnTwo;
            }

            if(tabs[index] === 'all'){
                this.columns = this.columnAll;
            }

            if(tabs[index] === 'pull-out'){
                this.endpoint = 'delivery/pull-out';
            }
        
            this.SetFilters({})
            this.SetPage(1)
            this.resetData(this.endpoint);
        },


        updatePurchaseOrderStatus(event,v,row){
            var self = this;
            if(event.target.checked === true){
                
                MessageBox.confirm('Are you sure you want to approve this purchase order?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        const formData = { 
                            hash : row.token_id,
                            status : 'approved'
                            }
                        self.fnUpdateStatus(formData)

                        //  return event.target.checked = true

                    })
                return event.target.checked = false
            }

            if(event.target.checked === false){
                
                MessageBox.confirm('Record will change status to "For Approval". Are you sure want to continue', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        const formData = { 
                            hash : row.token_id,
                            status : 'for-approval'
                            }
                        self.fnUpdateStatus(formData)

                        //  return event.target.checked = false

                    })
                return event.target.checked = true
            }

            return event.target.checked = false
        /* const self = this;
        console.log(event.target.checked)
        this.$emit("input", false) */
            /* if(v){
                MessageBox.confirm('Record will change status to "For Approval". Are you sure want to continue', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        const formData = { 
                            hash : row.token_id,
                            status : 'approved'
                            }
                        self.fnUpdateStatus(formData)

                        console.log(event.target);
                        this.$emit("input", event.target.checked)

                    })
            }else{
                MessageBox.confirm('Are you sure want to approve this purchase order?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                         const formData = { 
                            hash : row.token_id,
                            status : 'for-approval'
                            }
                        self.fnUpdateStatus(formData)
                    })
            } */
        /* if(self.FormStatus == 'update'){
            MessageBox.confirm('Are you sure you want to change status?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
                }).then(() => {

                    const formData = { 
                    hash : self.form.token_id,
                    status : status
                    }
                    self.updateStatus({endpoint : 'update-status',payload : formData}).then(() => {
                        self.$ThatsNotify.success({
                        message : "Record status was successfully changed"
                        })
                        self.closeDialog();
                        self.$emit('success')
                        self.FormResetter();
                        
                    }).catch((error) => {
                        self.formLoading = false
                        self.response.error = 1;
                        if (error.response) {
                            if(error.response.data.hasOwnProperty('errors')){
                            self.$refs.observer.setErrors(error.response.data.errors);
                            this.showError = true
                            }
                        } else if (error.request) {
                            self.response.message = error.request
                        } else {
                            self.response.message = error.message
                        }
                        return;
                    })

                })
            
        } */
        },

        fnUpdateStatus(formData){
            var self = this;
            self.updateStatus({endpoint : 'update-status',payload : formData}).then(() => {
                        self.$ThatsNotify.success({
                        message : "Record status was successfully changed"
                        })
                        self.refreshTable();
                    }).catch((error) => {
                        self.$ThatsNotify.success({
                        message : "Something wen't wrong"
                        })
                        self.refreshTable();
                    })
            
        }

    },
    computed: {
        ...mapGetters('DeliveryModule',[ 'data', 'page', 'total', 'page', 'length', 'getLoading', ]),
        checkSystemSupport : function(){
            const systemSupport = this.$helpers.isSystemAdministrator();
            return systemSupport
        }
    },
}


</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }

  .display-block{
      opacity: 1!important;pointer-events : initial!important
  }
</style>